module.exports = __webpack_public_path__ + "img/Mickies_Pizzeria@3x.9e0f114e.png";